export function getConfig() {
  return {
    startAppUri: process.env.REACT_APP_START_URL || 'https://start.ahau260.com'
  };
}
